// extracted by mini-css-extract-plugin
export default {"label":"h0HGnyskNby0gLJv7xhg","input-button-wrapper":"Rpm_gI2jaSsD4Y41RMZa","login-id-input":"TRqjJteFrtJ3SScgKEoO"};